import React, { useEffect, useRef, useState } from 'react';
import style from './FileUpload.module.css';
import { useLocation } from 'react-router-dom';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import { IMAGE_URL } from '../../../constants/url';
import HeadSub from '../../../components/comm/HeadSub';
import ToastPopup from '../../../components/comm/ToastPopup';
import Modal from '../../../components/comm/Modal';
import imgNoData from '../../../images/common/i_3d_no_data_doc.svg';
import iconPdf from '../../../images/common/i_file_pdf.svg';
import iconDocx from '../../../images/common/i_file_docx.svg';
import iconXls from '../../../images/common/i_file_xls.svg';
import iconPptx from '../../../images/common/i_file_pptx.svg';
import iconEct from '../../../images/common/i_file_ect.svg';

/**
 * 해외비대면 전용 첨부파일
 * @returns {JSX.Element}
 * @constructor
 */
const FileUpload = () => {

    /**************
     * 선언부
     ***************/

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const location = useLocation();
    const { state } = location;

    const [ requestData, setRequestData ] = useState( {
        telmdcApplId: state?.telmdcApplId || ""
        , patntAtchFileStr: state?.patntAtchFileStr || ""
        , mode: "add"
    });

    // 파일불러오기
    const [ patntAtchFileList, setPatntAtchFileList ] = useState( [] );
    // physical files
    const [files, setFiles] = useState([]);
    const [checkedFiles, setCheckedFiles] = useState([]);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false); //모달창

    // 화면초기화렌더제어 useRef 선언
    const isInitialRender = useRef(true);

    /**************
     * 기능부 구현
     ***************/

    const searchAttachFiles = (updateParams) => {

        const searchParams = updateParams || requestData;

        const requestUrl = "/overseas/retrieveTelemedicinePatientAttach";

        const jToken = localStorage.getItem("jToken");

        const requestParams = {
            telmdcApplId: searchParams?.telmdcApplId
            , patntAtchFileStr: searchParams?.patntAtchFileStr
        };

        const requestOptions = {
            headers: {
                "Authorization": `Bearer ${jToken}`
            },
        };

        axiosApi.post(requestUrl, requestParams, requestOptions)
            .then( (res) => {
                const resultData = res.data;

                if( resultData.resultCode === CODE.RCV_SUCCESS ) {
                    setPatntAtchFileList(resultData?.result?.patntAtchFileList);
                } else {
                    setPatntAtchFileList([]);
                }
            })
            .catch( (err) => {
                console.log( "===============> searchAttachFiles err : ", err );
            });
    };

    /**
     * 첨부파일 add 액션
     * @param event
     */
    const handleAddFiles = (event) => {

        const newSelectedFiles = Array.from(event.target.files).filter((file) => {

            return !files.some(existingFile => existingFile.file.name === file.name);
            }).map((file) => {
                let preview = null;
                let previewImg = null;
                if (file.type.startsWith('image/')) {
                    previewImg = URL.createObjectURL(file);
                } else {
                    const ext = file.name.split('.').pop().toLowerCase();
                    if (ext === 'pdf') {
                        preview = iconPdf;
                    } else if (ext === 'docx' || ext === 'doc') {
                        preview = iconDocx;
                    } else if (ext === 'xls' || ext === 'xlsx') {
                        preview = iconXls;
                    } else if (ext === 'ppt' || ext === 'pptx') {
                        preview = iconPptx;
                    } else {
                        preview = iconEct;
                    }
                }
                return {
                    file,
                    preview,
                    previewImg
                };
            });

        // 1. 클라이언트 파일 단 중복검사 비교 .. // 현재는 동일 네임만 체크 .. (사이즈단위까지 개선이 필요할수 있음 )
        if (newSelectedFiles.length < event.target.files.length) {
            setToastMessage('Duplicate files were not added.');
            setToast(true);
            return;
        }

        const serverFiles = patntAtchFileList || []; // 서버에서 가져온 상태 또는 빈 배열

        const finalSelectedFiles = newSelectedFiles.filter((newFileObj) => {
            const newFile = newFileObj.file;
            const newFileName = newFile.name;
            const newFileSize = newFile.size; // File 객체의 size

            // 서버 파일 중 동일한 파일명 && 파일사이즈인 항목이 있는지 확인..
            return !serverFiles.some((serverFile) =>
                serverFile?.orignlFileNm === newFileName && serverFile?.fileSize === newFileSize
            );
        });

        // 2. 서버 파일 state 와 중복 비교
        const totalDuplicates = event.target.files.length - finalSelectedFiles.length;
        if (totalDuplicates > 0) {
            setToastMessage(`${totalDuplicates} duplicate files (including server) were not added.`);
            setToast(true);
            // input 리셋 (중복으로 인해 추가된 파일 제거)
            event.target.value = null;
            return;
        }

        // 모바일특성에 맞게 개별저장처리로 ..
        saveAttachFiles(finalSelectedFiles, "add");

        setFiles((prevFiles) => [...prevFiles, ...finalSelectedFiles]);

        // 파일 처리 후 무조건 리셋..
        event.target.value = null;
    };

    /**
     * 첨부파일 저장 ( 추가 / 수정 / 삭제 )
     * @param selectedFiles
     * @param mode
     */
    const saveAttachFiles = (selectedFiles, mode) => {

        const requestUrl = "/overseas/saveTelemedicinePatientAttach";

        const jToken = localStorage.getItem("jToken");

        let requestParams = {};

        requestParams = {
            telmdcApplId: requestData?.telmdcApplId
            , patntAtchFileStr: requestData?.patntAtchFileStr ? requestData?.patntAtchFileStr.trim() : ""
            , mode: mode
            , usrInfoId: user.usrInfoId
        };

        const formData = new FormData();
        for ( let key in requestParams ) {
            formData.append( key, requestParams[key] );
        }

        if( mode === "add" ) {
            selectedFiles.forEach((attach, i) => {
                formData.append(`file_${i}`, attach.file);  // 명시적 append
            });
        } else if( mode === "del" ) {
            selectedFiles.forEach((attach, i) => {
                if( i === 0 ) {
                    formData.append("rmAtchFileId", attach?.atchFileId);
                    formData.append( "fileStrePath", attach?.fileStrePath );
                }
                formData.append( "rmFileSnList", attach?.fileSn );
                formData.append( "streNmList", attach?.streFileNm );
            });
        }
        // console.log( " ================> saveAttachFiles formdata entries :: ", Array.from(formData.entries()) );

        const requestOptions = {
            headers: {
                "Authorization" : `Bearer ${jToken}`
                , "Content-Type" : "multipart/form-data"
            },
            transformRequest: [
                function () {
                    return formData;
                },
            ],
        };

        axiosApi.post(requestUrl, formData, requestOptions)
            .then( (res) => {

                const resultData = res.data;
                if( resultData.resultCode === CODE.RCV_SUCCESS ) {

                    const updateParams = {
                        ...requestParams, patntAtchFileStr: resultData?.result?.atchFileStr
                    }
                    setRequestData(updateParams);
                    setFiles([]); // 초기화
                    searchAttachFiles(updateParams);
                } else { // 업로드 실패시 메시지처리..
                    setFiles([]); // 파일저장이 안되었다해도..즉시저장처리 이기때문에 파일을 초기화해준다.
                    setToastMessage("File upload failed");
                    setToast(true);
                }
            })
            .catch( (err => {
                console.log("==============> saveAttachFiles " + mode + " Error : ", err );
                setToastMessage("File upload failed (Error)");
                setToast(true);
            }));
    };

    // 체크 확인
    const handleCheck = (index) => {
        setCheckedFiles((prev) => {
            if (prev.includes(index)) {
                return prev.filter(i => i !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    // 삭제 처리 핸들링
    const handleDelete = () => {

        const selectedFiles = patntAtchFileList.filter((_, index) => checkedFiles.includes(index));

        // 서버 삭제 처리 ../
        saveAttachFiles(selectedFiles, "del");

        // 서버 처리 후 처리 ..
        setPatntAtchFileList( (prevFiles) =>
            prevFiles.filter((_, index) => !checkedFiles.includes(index))
        );

        setCheckedFiles([]);
        setIsOpen(false);
    };


    useEffect( () => {

        if(isInitialRender.current) {
            searchAttachFiles();
            isInitialRender.current = false;
        }
    });


    return (
        <>
            <HeadSub title="File Upload" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-add-padding={checkedFiles.length > 0 ? "bot" : ""}>
                    <div className={style['content-box']}>
                        <div className={style['file-upload-box']}>
                            <ul>

                                { // files.length === 0 ? (
                                   patntAtchFileList.length === 0 ? (
                                    <li className={style['no-data']}>
                                        <div className='animation-3'>
                                            <div className={style['img-box']}>
                                            <object data={imgNoData} aria-hidden='true'></object>
                                            </div>
                                            <p>There is no file.</p>
                                        </div>
                                    </li>
                                )
                                : //files.map((item, index) => ( // 실데이터 로드방식으로 변경.. ( files 는 저장용.. )
                                  patntAtchFileList.map((item, index) => (
                                    <li className="fileContainer" key={index}>
                                        <div className={style['chk-box']}>
                                            <div className={style["chkbox-custom"]}>
                                                <input
                                                    type="checkbox"
                                                    name={`chkId-${index}`}
                                                    id={`chkId-${index}`}
                                                    checked={checkedFiles.includes(index)}
                                                    onChange={() => handleCheck(index)}
                                                />
                                                <label htmlFor={`chkId-${index}`}>
                                                    <div className={style['img-box']}>

                                                        {(item?.atchFileStr && item?.fileSn ) && (
                                                            <img
                                                                //src={item.preview || item.previewImg}
                                                                src={`${IMAGE_URL}${item?.atchFileStr}&fileSn=${item?.fileSn}`}
                                                                alt={`preview-${index}`}
                                                                className={item?.fileSn ? style['preview-img'] : ''}
                                                            />
                                                        )}
                                                    </div>
                                                    <p>{item?.orignlFileNm}</p>
                                                    <span className={style['chk-box']}></span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    ))
                                }

                            </ul>
                        </div>
                    </div>
                    <div className="bottom-fixed-box" data-height="auto">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-direction="column">

                                {checkedFiles.length > 0 && (
                                    <div className='animation-3'>
                                    <button
                                        className='btn'
                                        data-btn-type="fill-main-sub"
                                        data-btn-size='lg'
                                        data-btn-width='full'
                                        onClick={()=>setIsOpen(true)}
                                    >
                                        <span>Delete</span>
                                    </button>
                                    </div>
                                )}

                                <div className={style['input-btn']}>
                                    <input
                                        type="file"
                                        id="ilfe-input"
                                        className={style["file-input"]}
                                        multiple
                                        hidden
                                        onChange={handleAddFiles}
                                    />
                                    <label htmlFor="ilfe-input">
                                        <span>Add</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                     {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            message={toastMessage}
                            setToast={setToast}
                            position="center"
                            opacity="90"
                        />
                    )}


                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> Delete File</p>
                        </div>
                        <div className="sub-box">
                            <span>Do you want to delete the selected file?</span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={()=> {setIsOpen(false); setCheckedFiles([]);}}>
                                <span>Cancel</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleDelete}>
                                <span>Delete</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default FileUpload;
